import React from "react";
import "./index.scss";

const Footer: React.FC = () => {

    return (
        <footer>
            <div className="link-section">
                <a href="/cookies"> Política de cookies</a>
                <a href="/privacidade"> Política de privacidade</a>
            </div>
        </footer>
    )

}

export default Footer;